export default {
    'AUTH.CREATE_PASSWORD.TITLE': 'Créer un mot de passe',
    'AUTH.CREATE_PASSWORD.TCS_APPROVE.TEXT': 'Je lis et accepte les',
    'AUTH.CREATE_PASSWORD.TCS_APPROVE.LINK_TEXT': 'CGV de Calizy',
    'AUTH.CREATE_PASSWORD.BUTTON': 'S\'inscrire',
    'AUTH.CREATE_PASSWORD.HEADER': 'Pour accéder à Calizy Pro, merci de créer votre mot de passe',
};
